<template>
  <div class="warm-up" :class="{ 'warm-up--disabled': viewOnly }">
    <p class="warm-up__title">{{ $t("read_aloud.warm_up.title") }}</p>
    <el-form class="warm-up__form" :class="{ 'warm-up__form--disabled': viewOnly }">
      <elsa-tags-input
        :placeholder="$t('study_sets.form.type_in_phrases_press_enter_to_seperate')"
        :maxTags="50"
        :validations="[]"
        :currentTags="words"
        :separators="[';']"
        :addOnkey="[13, '\n']"
        :allowEditTags="!viewOnly"
        :viewOnly="viewOnly"
        :maxCharactersAllow="300"
        displayTagsInRow
        information=""
        label=""
        ref="tags"
        name="phrases"
        @updatedTags="handleChange"
      />
      <el-row>
        <el-col>
          <div class="warm-up__footer">
            <primary-button @click.native="$emit('generate')" :disabled="disabled" size="large">
              {{ $t("read_aloud.form.button_generate") }}
            </primary-button>
          </div>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import PrimaryButton from "@/components/common/buttons/PrimaryButton";
import ElsaTagsInput from "@/components/common/TagsInput";
import { mapActions, mapGetters, mapState } from "vuex";

export default {
  props: {
    autoGenerateSets: {
      type: Array,
      default: () => [],
    },
    viewOnly: {
      type: Boolean,
      default: false,
    },
    finished: {
      type: Boolean,
      default: false,
    },
    listWarmUpEdit: {
      type: Array,
      default: () => [],
    },
    editWords: {
      type: Array,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  components: { ElsaTagsInput, PrimaryButton },
  data() {
    return {
      words: [],
    };
  },
  computed: {
    ...mapState("readAlouds", ["newReadAloud", "editReadAloud", "autoWarmUpStudySets", "finalWarmUpStudySets", "detailReadAloud", "warmUpInit"]),
    ...mapGetters("readAlouds", ["userFillStudySets"]),
    listWords() {
      return this.warmUpInit;
    },
  },

  watch: {
    autoWarmUpStudySets: {
      deep: true,
      immediate: true,
      handler(list) {
        this.words = list.concat(this.userFillStudySets);

        if(!list.length) return
        this.setFinalWarmUpStudySets(this.words);
      },
    },

    warmUpInit: {
      deep: true,
      immediate: true,
      handler(list) {
        if (this.editWords.length) {
          this.words = this.editWords;
          return;
        }

        if (!list.length) {
          return
        }

        this.words = list.map(el => ({ text: el, classes: "custom-tag", isAutoGenerated: true }));
      },
    },

  },
  methods: {
    ...mapActions("readAlouds", ["setFinalWarmUpStudySets", "getWarmUpStudySets", "cloneWarmUpAction", "setAutoWarmUpStudySets"]),
    handleChange(tags) {
      this.words = tags

      this.setFinalWarmUpStudySets(tags);
      this.$emit("change-warm-up", tags);

      const autoTags = tags.filter(tag => tag.isAutoGenerated)
      if (autoTags) {
        this.setAutoWarmUpStudySets(autoTags)
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.warm-up {

  &--disabled {
    pointer-events: none;
  }

  &__title {
    font-size: 17px;
    font-style: normal;
    font-weight: 510;
    margin-block-start: 0;
    margin-block-end: 0;
    margin-bottom: 12px;
  }

  &__disclaimer {
    display: flex;
    align-items: center;
    gap: 5px;
  }

  &__disclaimer-text {
    font-size: 15px;
    font-style: normal;
    font-weight: 400;
  }

  &__form {
    border: 1px solid #e6e6e6;
    border-radius: 8px;
    min-height: 300px;
    box-sizing: border-box;
    &--disabled {
      ::v-deep {
        .elsa-tags-input-custom {
          background: #eef4fe !important;
          border: none;
        }
      }
    }
  }

  &__footer {
    padding-left: 25px;
  }
}
::v-deep {
  .elsa-tags-input-custom {
    border: none;
  }
}
</style>
